'use strict'
import ScrollBooster from "scrollbooster";

let viewport = document.querySelector('.other-models_wrap');
if (viewport) {
    let box = document.querySelector('.other-models_box');
    new ScrollBooster({
        viewport: viewport,
        scrollMode: 'native',
        onUpdate: (data) => {
            if (data.borderCollision.left) {
                box.classList.remove('other-models_box_show-after');
                box.classList.add('other-models_box_show-before');
            } else if (data.borderCollision.right) {
                box.classList.remove('other-models_box_show-before');
                box.classList.add('other-models_box_show-after');
            } else {
                box.classList.add('other-models_box_show-before', 'other-models_box_show-after');
            }
        }
    })
}